import styled from "styled-components";

export const Container = styled.div<{disabled: boolean}>`
  background-color: ${props => props.theme.colors.inputBackground};
  border-radius: 50%;
  display: flex;
  width: 24px;
  height: 24px;
  padding: 2px;
  justify-content: center;
  align-items: center; 

  transition: all 0.5s;

  opacity: ${props => props.disabled ? 0.6 : 1};

  &:hover{
    cursor: ${props => props.disabled ? "normal" : "pointer"};
    scale: 1.1;
  }

  &:active{
    background-color: ${props => props.disabled ? '' : props.theme.colors.placeholder};
  }
`;
